var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18.488 19.83 16 19c-1.656 1.406-2.657 1.5-5 1.5a9.5 9.5 0 1 1 9.5-9.5c0 2.24-.702 3.876-2 5.5l1.051 2.103.949 1.897zm1.76-3.187C21.322 15.03 21.975 13.177 22 11c0-6.075-4.925-11-11-11S0 4.925 0 11s4.925 11 11 11c1.193 0 2.222-.04 3.143-.273.704-.197 1.422-.55 2.138-1.052l3.745 1.248a1.5 1.5 0 0 0 1.816-2.094z"
})));
export default SvgInstagramMobileComment;